export const hasSubGameListBrands = ["77lottery", "blockchain", "mg", "winlottery"];

//betInquiry subGames
const mg = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const blockchain = {
  isGameNameTranslate: true,
  translatePrefixKeyname: "game.name.",
  translateParamKey: "code",
  gameCodeApiKey: "code",
};

const minigame = {
  isGameNameTranslate: true,
  translatePrefixKeyname: `game.name.`,
  translateParamKey: "type",
  gameCodeApiKey: "type",
};

const lottery77 = {
  isGameNameTranslate: true,
  translatePrefixKeyname: "game.name.",
  translateParamKey: "type",
  gameCodeApiKey: "type",
};

const winlottery = {
  isGameNameTranslate: true,
  translatePrefixKeyname: `${process.env.REACT_APP_WIN_TRAN_NAME}.name.`,
  translateParamKey: "type",
  gameCodeApiKey: "type",
};

const t1 = {
  isGameNameTranslate: false,
  nameParamKey: "game_code",
  nameRender: (name) => name?.charAt(0)?.toUpperCase() + name?.slice(1),
  translatePrefixKeyname: "",
  translateParamKey: "game_code",
  gameCodeApiKey: "game_code",
};

const evo = {
  isGameNameTranslate: true,
  translatePrefixKeyname: "evo.gameType.",
  translateParamKey: "game_code",
  gameCodeApiKey: "game_code",
};

const pp = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const pg = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const ygg = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const evoplay = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const jili = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const jdb = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const pt = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const pplive = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const cq9 = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const fc = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const playstar = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const welottery = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const welive = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const weblockchain = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const tcg = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const jilifish = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const youbet = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const aesexy = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const spribeone = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const wesport = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const ybslot = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const wefish = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const weslot = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const fcfish = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const jdbfish = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const jdbslot = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const viacasinolive = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const ffflive = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const wcf = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onejdbslot = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onejdbfish = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onepp = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onepg = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onehacksaw = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onejilislot = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onejilifish = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onejilicard = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onejilicasino = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const oneevolive = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onepplive = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const onesaba = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};
const oneglobal = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};

const agglobal = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};
const omgglobal = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};
const sbosport = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};
const crsport = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};
const fbsport = {
  isGameNameTranslate: false,
  nameParamKey: "name",
  translatePrefixKeyname: "",
  translateParamKey: "",
  gameCodeApiKey: "code",
};
const defaultSetting = {
  isGameNameTranslate: true,
  translatePrefixKeyname: "game.name.",
  translateParamKey: "type",
  gameCodeApiKey: "type",
};

export const subGameListSetting = {
  mg,
  blockchain,
  minigame,
  "77lottery": lottery77,
  winlottery,
  t1,
  evo,
  pp,
  pg,
  ygg,
  evoplay,
  jili,
  jdb,
  pt,
  pplive,
  cq9,
  fc,
  playstar,
  welottery,
  welive,
  weblockchain,
  tcg,
  jilifish,
  youbet,
  aesexy,
  spribeone,
  wesport,
  ybslot,
  wefish,
  weslot,
  fcfish,
  jdbfish,
  jdbslot,
  viacasinolive,
  ffflive,
  wcf,
  onejdbslot,
  onejdbfish,
  onepp,
  onepg,
  onehacksaw,
  onejilislot,
  onejilifish,
  onejilicard,
  onejilicasino,
  oneevolive,
  onepplive,
  onesaba,
  onehabaneropoker: oneglobal,
  onekingmidaspoker: oneglobal,
  onekypoker: oneglobal,
  one365poker: oneglobal,
  onegtfslot: oneglobal,
  onemicroslot: oneglobal,
  onespadeslot: oneglobal,
  onerelaxslot: oneglobal,
  onehabaneroslot: oneglobal,
  onenetentslot: oneglobal,
  oneredtigerslot: oneglobal,
  onebigtimeslot: oneglobal,
  onenolimitcityslot: oneglobal,
  onebngslot: oneglobal,
  oneadvantplayslot: oneglobal,
  oneevoplayslot: oneglobal,
  onekingmidasslot: oneglobal,
  oneepicwinslot: oneglobal,
  onelive22slot: oneglobal,
  onecgslot: oneglobal,
  onedbslot: oneglobal,
  onethunderkickslot: oneglobal,
  onepaslot: oneglobal,
  oneplaytechslot: oneglobal,
  onealizeslot: oneglobal,
  oneavataruxslot: oneglobal,
  onethebetterslot: oneglobal,
  oneendorphinaslot: oneglobal,
  onelucky365slot: oneglobal,
  onewinfinitylive: oneglobal,
  oneyeebetlive: oneglobal,
  oneezugilive: oneglobal,
  onemicrolive: oneglobal,
  onepalive: oneglobal,
  oneaasexylive: oneglobal,
  onewmlive: oneglobal,
  oneplaytechlive: oneglobal,
  onedblive: oneglobal,
  onecq9live: oneglobal,
  onebiglive: oneglobal,
  onealizemini: oneglobal,
  oneaviatrixmini: oneglobal,
  onelitemini: oneglobal,
  oneaviatormini: oneglobal,
  onemicroarcade: oneglobal,
  agjilislot: agglobal,
  agpgslot: agglobal,
  agppslot: agglobal,
  agjdbslot: agglobal,
  agbgslot: agglobal,
  agfcslot: agglobal,
  agcpslot: agglobal,
  agwgslot: agglobal,
  agtadaslot: agglobal,
  aghsdslot: agglobal,
  omgspribe: omgglobal,
  omgpgslot: omgglobal,
  omgppslot: omgglobal,
  omghacksaw: omgglobal,
  omgjilislot: omgglobal,
  omgminigame: omgglobal,
  omgtadaslot: omgglobal,
  omgcpslot: omgglobal,
  omgaskmeslot: omgglobal,
  omglottery: omgglobal,
  omgcasino: omgglobal,
  omgjdbslot: omgglobal,
  omgwgslot: omgglobal,
  omg759slot: omgglobal,
  omgredtiger: omgglobal,
  omgfcslot: omgglobal,
  omgigtslot: omgglobal,
  omg2jgame: omgglobal,
  omgslotmill: omgglobal,
  omggameartslot: omgglobal,
  sbosport,
  crsport,
  fbsport,
  default: defaultSetting,
};
